export default {
    "Adder": {
        img: "adder",
        desc: "",
        name: "Adder",
        model: "",
        seats: 2,
        acceleration: 5.2,
        maxSpeed: 0
    },
    "Alpha": {
        img: "alpha",
        desc: "",
        name: "Alpha",
        model: "",
        seats: 2,
        acceleration: 5.5,
        maxSpeed: 0
    },
    "Autarch": {
        img: "autarch",
        desc: "",
        name: "Autarch",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Banshee": {
        img: "banshee",
        desc: "",
        name: "Banshee",
        model: "",
        seats: 2,
        acceleration: 5.6,
        maxSpeed: 0
    },
    "Banshee2": {
        img: "banshee2",
        desc: "",
        name: "Banshee2",
        model: "",
        seats: 2,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "BestiaGTS": {
        img: "bestiagts",
        desc: "",
        name: "BestiaGTS",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Bifta": {
        img: "bifta",
        desc: "",
        name: "Bifta",
        model: "",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0
    },
    "Blista": {
        img: "blista",
        desc: "",
        name: "Blista",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Blista2": {
        img: "blista2",
        desc: "",
        name: "Blista2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Blista3": {
        img: "blista3",
        desc: "",
        name: "Blista3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Brawler": {
        img: "brawler",
        desc: "",
        name: "Brawler",
        model: "",
        seats: 2,
        acceleration: 5.2,
        maxSpeed: 0
    },
    "Brioso": {
        img: "brioso",
        desc: "",
        name: "Brioso",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Brioso2": {
        img: "brioso2",
        desc: "",
        name: "Brioso2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Buccaneer2": {
        img: "buccaneer2",
        desc: "",
        name: "Buccaneer2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Buffalo": {
        img: "buffalo",
        desc: "",
        name: "Buffalo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Buffalo2": {
        img: "buffalo2",
        desc: "",
        name: "Buffalo2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Buffalo3": {
        img: "buffalo3",
        desc: "",
        name: "Buffalo3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Bullet": {
        img: "bullet",
        desc: "",
        name: "Bullet",
        model: "",
        seats: 2,
        acceleration: 6,
        maxSpeed: 0
    },
    "Caddy": {
        img: "caddy",
        desc: "",
        name: "Caddy",
        model: "",
        seats: 2,
        acceleration: 17.5,
        maxSpeed: 0
    },
    "Calico": {
        img: "calico",
        desc: "",
        name: "Calico",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Camry": {
        img: "camry",
        desc: "",
        name: "Camry",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Carbonizzare": {
        img: "carbonizzare",
        desc: "",
        name: "Carbonizzare",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Caracara2": {
        img: "caracara2",
        desc: "",
        name: "Caracara2",
        model: "",
        seats: 4,
        acceleration: 5.6,
        maxSpeed: 0
    },
    "Casco": {
        img: "casco",
        desc: "",
        name: "Casco",
        model: "",
        seats: 2,
        acceleration: 5.8,
        maxSpeed: 0
    },
    "Cheburek": {
        img: "cheburek",
        desc: "",
        name: "Cheburek",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Cheetah": {
        img: "cheetah",
        desc: "",
        name: "Cheetah",
        model: "",
        seats: 2,
        acceleration: 4.9,
        maxSpeed: 0
    },
    "Cheetah2": {
        img: "cheetah2",
        desc: "",
        name: "Cheetah2",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Chino": {
        img: "chino",
        desc: "",
        name: "Chino",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Chino2": {
        img: "chino2",
        desc: "",
        name: "Chino2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Cinquemila": {
        img: "cinquemila",
        desc: "",
        name: "Cinquemila",
        model: "",
        seats: 4,
        acceleration: 8,
        maxSpeed: 0
    },
    "Club": {
        img: "club",
        desc: "",
        name: "Club",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Cog55": {
        img: "cog55",
        desc: "",
        name: "Cog55",
        model: "",
        seats: 4,
        acceleration: 6.8,
        maxSpeed: 0
    },
    "Cogcabrio": {
        img: "cogcabrio",
        desc: "",
        name: "Cogcabrio",
        model: "",
        seats: 2,
        acceleration: 6.8,
        maxSpeed: 0
    },
    "Cognoscenti": {
        img: "cognoscenti",
        desc: "",
        name: "Cognoscenti",
        model: "",
        seats: 4,
        acceleration: 7.4,
        maxSpeed: 0
    },
    "Comet2": {
        img: "comet2",
        desc: "",
        name: "Comet2",
        model: "",
        seats: 2,
        acceleration: 5.3,
        maxSpeed: 0
    },
    "Comet3": {
        img: "comet3",
        desc: "",
        name: "Comet3",
        model: "",
        seats: 0,
        acceleration: 5,
        maxSpeed: 0
    },
    "Comet5": {
        img: "comet5",
        desc: "",
        name: "Comet5",
        model: "",
        seats: 2,
        acceleration: 3.9,
        maxSpeed: 0
    },
    "Comet6": {
        img: "comet6",
        desc: "",
        name: "Comet6",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Comet7": {
        img: "comet7",
        desc: "",
        name: "Comet7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Contender": {
        img: "contender",
        desc: "",
        name: "Contender",
        model: "",
        seats: 4,
        acceleration: 5.9,
        maxSpeed: 0
    },
    "Coquette": {
        img: "coquette",
        desc: "",
        name: "Coquette",
        model: "",
        seats: 2,
        acceleration: 5.7,
        maxSpeed: 0
    },
    "Coquette2": {
        img: "coquette2",
        desc: "",
        name: "Coquette2",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Coquette3": {
        img: "coquette3",
        desc: "",
        name: "Coquette3",
        model: "",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0
    },
    "Coquette4": {
        img: "coquette4",
        desc: "",
        name: "Coquette4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Corsita": {
        img: "corsita",
        desc: "",
        name: "Corsita",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Cyclone": {
        img: "cyclone",
        desc: "",
        name: "Cyclone",
        model: "",
        seats: 2,
        acceleration: 2.6,
        maxSpeed: 0
    },
    "Cypher": {
        img: "cypher",
        desc: "",
        name: "Cypher",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Deviant": {
        img: "deviant",
        desc: "",
        name: "Deviant",
        model: "",
        seats: 2,
        acceleration: 7.8,
        maxSpeed: 0
    },
    "Deveste": {
        img: "deveste",
        desc: "",
        name: "Deveste",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dilettante": {
        img: "dilettante",
        desc: "",
        name: "Dilettante",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dloader": {
        img: "dloader",
        desc: "",
        name: "Dloader",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dominator": {
        img: "dominator",
        desc: "",
        name: "Dominator",
        model: "",
        seats: 2,
        acceleration: 7.3,
        maxSpeed: 0
    },
    "Dominator2": {
        img: "dominator2",
        desc: "",
        name: "Dominator2",
        model: "",
        seats: 2,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "Dominator3": {
        img: "dominator3",
        desc: "",
        name: "Dominator3",
        model: "",
        seats: 2,
        acceleration: 6.8,
        maxSpeed: 0
    },
    "Dominator7": {
        img: "dominator7",
        desc: "",
        name: "Dominator7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dominator8": {
        img: "dominator8",
        desc: "",
        name: "Dominator8",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Drafter": {
        img: "drafter",
        desc: "",
        name: "Drafter",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Dubsta": {
        img: "dubsta",
        desc: "",
        name: "Dubsta",
        model: "",
        seats: 4,
        acceleration: 10,
        maxSpeed: 0
    },
    "Dubsta2": {
        img: "dubsta2",
        desc: "",
        name: "Dubsta2",
        model: "",
        seats: 0,
        acceleration: 10,
        maxSpeed: 0
    },
    "Dubsta3": {
        img: "dubsta3",
        desc: "",
        name: "Dubsta3",
        model: "",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0
    },
    "Dukes": {
        img: "dukes",
        desc: "",
        name: "Dukes",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dukes3": {
        img: "dukes3",
        desc: "",
        name: "Dukes3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Dynasty": {
        img: "dynasty",
        desc: "",
        name: "Dynasty",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Elegy": {
        img: "elegy",
        desc: "",
        name: "Elegy",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Elegy2": {
        img: "elegy2",
        desc: "",
        name: "Elegy2",
        model: "",
        seats: 2,
        acceleration: 5.3,
        maxSpeed: 0
    },
    "Ellie": {
        img: "ellie",
        desc: "",
        name: "Ellie",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Emerus": {
        img: "emerus",
        desc: "",
        name: "Emerus",
        model: "",
        seats: 2,
        acceleration: 4.4,
        maxSpeed: 0
    },
    "Emperor": {
        img: "emperor",
        desc: "",
        name: "Emperor",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Emperor2": {
        img: "emperor2",
        desc: "",
        name: "Emperor2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "EntityXF": {
        img: "entityfx",
        desc: "",
        name: "EntityXF",
        model: "",
        seats: 2,
        acceleration: 4.3,
        maxSpeed: 0
    },
    "Entity2": {
        img: "entity2",
        desc: "",
        name: "Entity2",
        model: "",
        seats: 2,
        acceleration: 4.2,
        maxSpeed: 0
    },
    "Euros": {
        img: "euros",
        desc: "",
        name: "Euros",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Exemplar": {
        img: "exemplar",
        desc: "",
        name: "Exemplar",
        model: "",
        seats: 4,
        acceleration: 6.8,
        maxSpeed: 0
    },
    "F620": {
        img: "f620",
        desc: "",
        name: "F620",
        model: "",
        seats: 2,
        acceleration: 6.7,
        maxSpeed: 0
    },
    "Faction": {
        img: "faction",
        desc: "",
        name: "Faction",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Faction2": {
        img: "faction2",
        desc: "",
        name: "Faction2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Fagaloa": {
        img: "fagaloa",
        desc: "",
        name: "Fagaloa",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Felon": {
        img: "felon",
        desc: "",
        name: "Felon",
        model: "",
        seats: 4,
        acceleration: 0,
        maxSpeed: 0
    },
    "Felon2": {
        img: "felon2",
        desc: "",
        name: "Felon2",
        model: "",
        seats: 4,
        acceleration: 7.2,
        maxSpeed: 0
    },
    "Feltzer2": {
        img: "feltzer2",
        desc: "",
        name: "Feltzer2",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Feltzer3": {
        img: "feltzer3",
        desc: "",
        name: "Feltzer3",
        model: "",
        seats: 2,
        acceleration: 6,
        maxSpeed: 0
    },
    "Flashgt": {
        img: "flashgt",
        desc: "",
        name: "Flashgt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Fmj": {
        img: "fmj",
        desc: "",
        name: "Fmj",
        model: "",
        seats: 2,
        acceleration: 4.3,
        maxSpeed: 0
    },
    "Fq2": {
        img: "fq2",
        desc: "",
        name: "Fq2",
        model: "",
        seats: 4,
        acceleration: 10.3,
        maxSpeed: 0
    },
    "Fugitive": {
        img: "fugitive",
        desc: "",
        name: "Fugitive",
        model: "",
        seats: 4,
        acceleration: 8.3,
        maxSpeed: 0
    },
    "Furia": {
        img: "furia",
        desc: "",
        name: "Furia",
        model: "",
        seats: 2,
        acceleration: 3.4,
        maxSpeed: 0
    },
    "Furoregt": {
        img: "furoregt",
        desc: "",
        name: "Furoregt",
        model: "",
        seats: 2,
        acceleration: 5.6,
        maxSpeed: 0
    },
    "Fusilade": {
        img: "fusilade",
        desc: "",
        name: "Fusilade",
        model: "",
        seats: 2,
        acceleration: 6,
        maxSpeed: 0
    },
    "Futo": {
        img: "futo",
        desc: "",
        name: "Futo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Futo2": {
        img: "futo2",
        desc: "",
        name: "Futo2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Gb200": {
        img: "gb200",
        desc: "",
        name: "Gb200",
        model: "",
        seats: 0,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "Glendale": {
        img: "glendale",
        desc: "",
        name: "Glendale",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Glendale2": {
        img: "glendale2",
        desc: "",
        name: "Glendale2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "GP1": {
        img: "gp1",
        desc: "",
        name: "GP1",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Gresley": {
        img: "gresley",
        desc: "",
        name: "Gresley",
        model: "",
        seats: 4,
        acceleration: 9.5,
        maxSpeed: 0
    },
    "Growler": {
        img: "growler",
        desc: "",
        name: "Growler",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Gt500": {
        img: "gt500",
        desc: "",
        name: "Gt500",
        model: "",
        seats: 2,
        acceleration: 6.5,
        maxSpeed: 0
    },
    "Habanero": {
        img: "habanero",
        desc: "",
        name: "Habanero",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Hellion": {
        img: "hellion",
        desc: "",
        name: "Hellion",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Hermes": {
        img: "hermes",
        desc: "",
        name: "Hermes",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Hotknife": {
        img: "hotknife",
        desc: "",
        name: "Hotknife",
        model: "",
        seats: 2,
        acceleration: 6.6,
        maxSpeed: 0
    },
    "Hotring": {
        img: "hotring",
        desc: "",
        name: "Hotring",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Huntley": {
        img: "huntley",
        desc: "",
        name: "Huntley",
        model: "",
        seats: 4,
        acceleration: 7.1,
        maxSpeed: 0
    },
    "Imorgon": {
        img: "imorgon",
        desc: "",
        name: "Imorgon",
        model: "",
        seats: 2,
        acceleration: 3,
        maxSpeed: 0
    },
    "Imperator": {
        img: "imperator",
        desc: "",
        name: "Imperator",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Infernus": {
        img: "infernus",
        desc: "",
        name: "Infernus",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Infernus2": {
        img: "infernus2",
        desc: "",
        name: "Infernus2",
        model: "",
        seats: 2,
        acceleration: 5.1,
        maxSpeed: 0
    },
    "Ingot": {
        img: "ingot",
        desc: "",
        name: "Ingot",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Intruder": {
        img: "intruder",
        desc: "",
        name: "Intruder",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Issi2": {
        img: "issi2",
        desc: "",
        name: "Issi2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Issi3": {
        img: "issi3",
        desc: "",
        name: "Issi3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Issi7": {
        img: "issi7",
        desc: "",
        name: "Issi7",
        model: "",
        seats: 2,
        acceleration: 4.3,
        maxSpeed: 0
    },
    "Italigtb": {
        img: "italigtb",
        desc: "",
        name: "Italigtb",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Italigto": {
        img: "italigto",
        desc: "",
        name: "Italigto",
        model: "",
        seats: 2,
        acceleration: 3.6,
        maxSpeed: 0
    },
    "Iwagon": {
        img: "iwagen",
        desc: "",
        name: "Iwagon",
        model: "",
        seats: 4,
        acceleration: 1,
        maxSpeed: 0
    },
    "Jackal": {
        img: "jackal",
        desc: "",
        name: "Jackal",
        model: "",
        seats: 4,
        acceleration: 8.8,
        maxSpeed: 0
    },
    "Jb7002": {
        img: "jb7002",
        desc: "",
        name: "Jb7002",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Jester": {
        img: "jester",
        desc: "",
        name: "Jester",
        model: "",
        seats: 2,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "Jester2": {
        img: "jester2",
        desc: "",
        name: "Jester2",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Jester3": {
        img: "jester3",
        desc: "",
        name: "Jester3",
        model: "",
        seats: 2,
        acceleration: 5.3,
        maxSpeed: 0
    },
    "Jester4": {
        img: "jester4",
        desc: "",
        name: "Jester4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Jugular": {
        img: "jugular",
        desc: "",
        name: "Jugular",
        model: "",
        seats: 4,
        acceleration: 3.6,
        maxSpeed: 0
    },
    "Kanjo": {
        img: "kanjo",
        desc: "",
        name: "Kanjo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Khamelion": {
        img: "khamelion",
        desc: "",
        name: "Khamelion",
        model: "",
        seats: 2,
        acceleration: 4.8,
        maxSpeed: 0
    },
    "Komoda": {
        img: "komoda",
        desc: "",
        name: "Komoda",
        model: "",
        seats: 4,
        acceleration: 4.4,
        maxSpeed: 0
    },
    "Kuruma": {
        img: "kuruma",
        desc: "",
        name: "Kuruma",
        model: "",
        seats: 4,
        acceleration: 5.7,
        maxSpeed: 0
    },
    "Landstalker": {
        img: "landstalker",
        desc: "",
        name: "Landstalker",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Landstalker2": {
        img: "landstalker2",
        desc: "",
        name: "Landstalker2",
        model: "",
        seats: 4,
        acceleration: 5,
        maxSpeed: 0
    },
    "Lectro": {
        img: "lectro",
        desc: "",
        name: "Lectro",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Locust": {
        img: "locust",
        desc: "",
        name: "Locust",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Lynx": {
        img: "lynx",
        desc: "",
        name: "Lynx",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Mamba": {
        img: "mamba",
        desc: "",
        name: "Mamba",
        model: "",
        seats: 2,
        acceleration: 6.2,
        maxSpeed: 0
    },
    "Manana": {
        img: "manana",
        desc: "",
        name: "Manana",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Manana2": {
        img: "manana2",
        desc: "",
        name: "Manana2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Massacro": {
        img: "massacro",
        desc: "",
        name: "Massacro",
        model: "",
        seats: 2,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "Massacro2": {
        img: "massacro2",
        desc: "",
        name: "Massacro2",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Minivan": {
        img: "minivan",
        desc: "",
        name: "Minivan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Monroe": {
        img: "monroe",
        desc: "",
        name: "Monroe",
        model: "",
        seats: 2,
        acceleration: 6.5,
        maxSpeed: 0
    },
    "Moonbeam2": {
        img: "moonbeam2",
        desc: "",
        name: "Moonbeam2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Nebula": {
        img: "nebula",
        desc: "",
        name: "Nebula",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Neo": {
        img: "neo",
        desc: "",
        name: "Neo",
        model: "",
        seats: 2,
        acceleration: 3.6,
        maxSpeed: 0
    },
    "Neon": {
        img: "neon",
        desc: "",
        name: "Neon",
        model: "",
        seats: 4,
        acceleration: 2.6,
        maxSpeed: 0
    },
    "Nero": {
        img: "nero",
        desc: "",
        name: "Nero",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Nightshade": {
        img: "nightshade",
        desc: "",
        name: "Nightshade",
        model: "",
        seats: 2,
        acceleration: 7.8,
        maxSpeed: 0
    },
    "Ninef": {
        img: "ninef",
        desc: "",
        name: "Ninef",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Ninef2": {
        img: "ninef2",
        desc: "",
        name: "Ninef2",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Novak": {
        img: "novak",
        desc: "",
        name: "Novak",
        model: "",
        seats: 4,
        acceleration: 4.9,
        maxSpeed: 0
    },
    "Omnis": {
        img: "omnis",
        desc: "",
        name: "Omnis",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Omnisegt": {
        img: "omnisegt",
        desc: "",
        name: "Omnisegt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Oracle": {
        img: "oracle",
        desc: "",
        name: "Oracle",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Oracle2": {
        img: "oracle2",
        desc: "",
        name: "Oracle2",
        model: "",
        seats: 4,
        acceleration: 6.4,
        maxSpeed: 0
    },
    "Osiris": {
        img: "osiris",
        desc: "",
        name: "Osiris",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Outlaw": {
        img: "outlaw",
        desc: "",
        name: "Outlaw",
        model: "",
        seats: 2,
        acceleration: 4.4,
        maxSpeed: 0
    },
    "Panto": {
        img: "panto",
        desc: "",
        name: "Panto",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Paragon": {
        img: "paragon",
        desc: "",
        name: "Paragon",
        model: "",
        seats: 2,
        acceleration: 4.4,
        maxSpeed: 0
    },
    "Pariah": {
        img: "pariah",
        desc: "",
        name: "Pariah",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Patriot": {
        img: "patriot",
        desc: "",
        name: "Patriot",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Penetrator": {
        img: "penetrator",
        desc: "",
        name: "Penetrator",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Penumbra": {
        img: "penumbra",
        desc: "",
        name: "Penumbra",
        model: "",
        seats: 2,
        acceleration: 8.6,
        maxSpeed: 0
    },
    "Penumbra2": {
        img: "penumbra2",
        desc: "",
        name: "Penumbra2",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Peyote": {
        img: "peyote",
        desc: "",
        name: "Peyote",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Peyote3": {
        img: "peyote3",
        desc: "",
        name: "Peyote3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Pfister811": {
        img: "pfister811",
        desc: "",
        name: "Pfister811",
        model: "",
        seats: 2,
        acceleration: 3.7,
        maxSpeed: 0
    },
    "Phoenix": {
        img: "phoenix",
        desc: "",
        name: "Phoenix",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Picador": {
        img: "picador",
        desc: "",
        name: "Picador",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Prairie": {
        img: "prairie",
        desc: "",
        name: "Prairie",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Premier": {
        img: "premier",
        desc: "",
        name: "Premier",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Previon": {
        img: "previon",
        desc: "",
        name: "Previon",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Primo": {
        img: "primo",
        desc: "",
        name: "Primo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Primo2": {
        img: "primo2",
        desc: "",
        name: "Primo2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Radi": {
        img: "radi",
        desc: "",
        name: "Radi",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "RancherXL": {
        img: "rancherxl",
        desc: "",
        name: "RancherXL",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Rapidgt": {
        img: "rapidgt",
        desc: "",
        name: "Rapidgt",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Rapidgt2": {
        img: "rapidgt2",
        desc: "",
        name: "Rapidgt2",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Rapidgt3": {
        img: "rapidgt3",
        desc: "",
        name: "Rapidgt3",
        model: "",
        seats: 2,
        acceleration: 5.8,
        maxSpeed: 0
    },
    "Ratbike": {
        img: "ratbike",
        desc: "",
        name: "Ratbike",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Ratloader2": {
        img: "ratloader2",
        desc: "",
        name: "Ratloader2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Rebel": {
        img: "rebel",
        desc: "",
        name: "Rebel",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Rebel2": {
        img: "rebel2",
        desc: "",
        name: "Rebel2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Rebla": {
        img: "rebla",
        desc: "",
        name: "Rebla",
        model: "",
        seats: 4,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Reaper": {
        img: "reaper",
        desc: "",
        name: "Reaper",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Reever": {
        img: "reever",
        desc: "",
        name: "Reever",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Regina": {
        img: "regina",
        desc: "",
        name: "Regina",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Remus": {
        img: "remus",
        desc: "",
        name: "Remus",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Retinue": {
        img: "retinue",
        desc: "",
        name: "Retinue",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Retinue2": {
        img: "retinue2",
        desc: "",
        name: "Retinue2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Revolter": {
        img: "revolter",
        desc: "",
        name: "Revolter",
        model: "",
        seats: 4,
        acceleration: 3.9,
        maxSpeed: 0
    },
    "Rhapsody": {
        img: "rhapsody",
        desc: "",
        name: "Rhapsody",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Rocoto": {
        img: "rocoto",
        desc: "",
        name: "Rocoto",
        model: "",
        seats: 4,
        acceleration: 9.1,
        maxSpeed: 0
    },
    "Romero": {
        img: "romero",
        desc: "",
        name: "Romero",
        model: "",
        seats: 4,
        acceleration: 15.2,
        maxSpeed: 0
    },
    "Rt3000": {
        img: "rt3000",
        desc: "",
        name: "Rt3000",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Ruiner": {
        img: "ruiner",
        desc: "",
        name: "Ruiner",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Ruston": {
        img: "ruston",
        desc: "",
        name: "Ruston",
        model: "",
        seats: 2,
        acceleration: 4.9,
        maxSpeed: 0
    },
    "Sabregt": {
        img: "sabregt",
        desc: "",
        name: "Sabregt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sabregt2": {
        img: "sabregt2",
        desc: "",
        name: "Sabregt2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sandking": {
        img: "sandking",
        desc: "",
        name: "Sandking",
        model: "",
        seats: 4,
        acceleration: 9.3,
        maxSpeed: 0
    },
    "Sandking2": {
        img: "sandking2",
        desc: "",
        name: "Sandking2",
        model: "",
        seats: 4,
        acceleration: 9.5,
        maxSpeed: 0
    },
    "Savestra": {
        img: "savestra",
        desc: "",
        name: "Savestra",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sc1": {
        img: "sc1",
        desc: "",
        name: "Sc1",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Schafter2": {
        img: "schafter2",
        desc: "",
        name: "Schafter2",
        model: "",
        seats: 4,
        acceleration: 7.1,
        maxSpeed: 0
    },
    "Schafter3": {
        img: "schafter3",
        desc: "",
        name: "Schafter3",
        model: "",
        seats: 4,
        acceleration: 5.5,
        maxSpeed: 0
    },
    "Schafter4": {
        img: "schafter4",
        desc: "",
        name: "Schafter4",
        model: "",
        seats: 4,
        acceleration: 8.5,
        maxSpeed: 0
    },
    "Schlagen": {
        img: "schlagen",
        desc: "",
        name: "Schlagen",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Schwarzer": {
        img: "schwarzer",
        desc: "",
        name: "Schwarzer",
        model: "",
        seats: 2,
        acceleration: 6.7,
        maxSpeed: 0
    },
    "Seminole": {
        img: "seminole",
        desc: "",
        name: "Seminole",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Seminole2": {
        img: "seminole2",
        desc: "",
        name: "Seminole2",
        model: "",
        seats: 4,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sentinel": {
        img: "sentinel",
        desc: "",
        name: "Sentinel",
        model: "",
        seats: 2,
        acceleration: 8.3,
        maxSpeed: 0
    },
    "Sentinel2": {
        img: "sentinel2",
        desc: "",
        name: "Sentinel2",
        model: "",
        seats: 2,
        acceleration: 8.5,
        maxSpeed: 0
    },
    "Sentinel3": {
        img: "sentinel3",
        desc: "",
        name: "Sentinel3",
        model: "",
        seats: 2,
        acceleration: 5.3,
        maxSpeed: 0
    },
    "Serrano": {
        img: "serrano",
        desc: "",
        name: "Serrano",
        model: "",
        seats: 4,
        acceleration: 9.1,
        maxSpeed: 0
    },
    "Seven70": {
        img: "seven70",
        desc: "",
        name: "Seven70",
        model: "",
        seats: 2,
        acceleration: 5.2,
        maxSpeed: 0
    },
    "Shotaro": {
        img: "shotaro",
        desc: "",
        name: "Shotaro",
        model: "",
        seats: 1,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sm722": {
        img: "sm722",
        desc: "",
        name: "Sm722",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Slamvan": {
        img: "slamvan",
        desc: "",
        name: "Slamvan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Stafford": {
        img: "stafford",
        desc: "",
        name: "Stafford",
        model: "",
        seats: 4,
        acceleration: 11.4,
        maxSpeed: 0
    },
    "Stalion": {
        img: "stalion",
        desc: "",
        name: "Stalion",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Stalion2": {
        img: "stalion2",
        desc: "",
        name: "Stalion2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Stanier": {
        img: "stanier",
        desc: "",
        name: "Stanier",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Stinger": {
        img: "stinger",
        desc: "",
        name: "Stinger",
        model: "",
        seats: 2,
        acceleration: 7.3,
        maxSpeed: 0
    },
    "Stingergt": {
        img: "stingergt",
        desc: "",
        name: "Stingergt",
        model: "",
        seats: 2,
        acceleration: 7.3,
        maxSpeed: 0
    },
    "Stratum": {
        img: "stratum",
        desc: "",
        name: "Stratum",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Sugoi": {
        img: "sugoi",
        desc: "",
        name: "Sugoi",
        model: "",
        seats: 4,
        acceleration: 6,
        maxSpeed: 0
    },
    "Sultan": {
        img: "sultan",
        desc: "",
        name: "Sultan",
        model: "",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0
    },
    "Sultan2": {
        img: "sultan2",
        desc: "",
        name: "Sultan2",
        model: "",
        seats: 4,
        acceleration: 5.3,
        maxSpeed: 0
    },
    "Sultan3": {
        img: "sultan3",
        desc: "",
        name: "Sultan3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "SultanRS": {
        img: "sultanrs",
        desc: "",
        name: "SultanRS",
        model: "",
        seats: 2,
        acceleration: 4.3,
        maxSpeed: 0
    },
    "Superd": {
        img: "superd",
        desc: "",
        name: "Superd",
        model: "",
        seats: 4,
        acceleration: 7.6,
        maxSpeed: 0
    },
    "Surano": {
        img: "surano",
        desc: "",
        name: "Surano",
        model: "",
        seats: 2,
        acceleration: 5.4,
        maxSpeed: 0
    },
    "Surge": {
        img: "surge",
        desc: "",
        name: "Surge",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Swinger": {
        img: "swinger",
        desc: "",
        name: "Swinger",
        model: "",
        seats: 2,
        acceleration: 5.5,
        maxSpeed: 0
    },
    "T20": {
        img: "t20",
        desc: "",
        name: "T20",
        model: "",
        seats: 2,
        acceleration: 3.3,
        maxSpeed: 0
    },
    "Tailgater": {
        img: "tailgater",
        desc: "",
        name: "Tailgater",
        model: "",
        seats: 4,
        acceleration: 8.8,
        maxSpeed: 0
    },
    "Tailgater2": {
        img: "tailgater2",
        desc: "",
        name: "Tailgater2",
        model: "",
        seats: 4,
        acceleration: 6,
        maxSpeed: 0
    },
    "Taipan": {
        img: "taipan",
        desc: "",
        name: "Taipan",
        model: "",
        seats: 2,
        acceleration: 4.8,
        maxSpeed: 0
    },
    "Tampa": {
        img: "tampa",
        desc: "",
        name: "Tampa",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tampa2": {
        img: "tampa2",
        desc: "",
        name: "Tampa2",
        model: "",
        seats: 2,
        acceleration: 4.7,
        maxSpeed: 0
    },
    "Tempesta": {
        img: "tempesta",
        desc: "",
        name: "Tempesta",
        model: "",
        seats: 2,
        acceleration: 4.1,
        maxSpeed: 0
    },
    "Thrax": {
        img: "thrax",
        desc: "",
        name: "Thrax",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "Tigon": {
        img: "tigon",
        desc: "",
        name: "Tigon",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Torero": {
        img: "torero",
        desc: "",
        name: "Torero",
        model: "",
        seats: 2,
        acceleration: 5.5,
        maxSpeed: 0
    },
    "Torero2": {
        img: "torero2",
        desc: "",
        name: "Torero2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tornado": {
        img: "tornado",
        desc: "",
        name: "Tornado",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tornado2": {
        img: "tornado2",
        desc: "",
        name: "Tornado2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tornado3": {
        img: "tornado3",
        desc: "",
        name: "Tornado3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tornado4": {
        img: "tornado4",
        desc: "",
        name: "Tornado4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Tornado5": {
        img: "tornado5",
        desc: "",
        name: "Tornado5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Toros": {
        img: "toros",
        desc: "",
        name: "Toros",
        model: "",
        seats: 4,
        acceleration: 4.8,
        maxSpeed: 0
    },
    "Tropos": {
        img: "tropos",
        desc: "",
        name: "Tropos",
        model: "",
        seats: 2,
        acceleration: 6.1,
        maxSpeed: 0
    },
    "Trophytruck": {
        img: "trophytruck",
        desc: "",
        name: "Trophytruck",
        model: "",
        seats: 2,
        acceleration: 5,
        maxSpeed: 0
    },
    "Tulip": {
        img: "tulip",
        desc: "",
        name: "Tulip",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Turismor": {
        img: "turismor",
        desc: "",
        name: "Turismor",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "Turismo2": {
        img: "turismo2",
        desc: "",
        name: "Turismo2",
        model: "",
        seats: 2,
        acceleration: 5.1,
        maxSpeed: 0
    },
    "Vacca": {
        img: "vacca",
        desc: "",
        name: "Vacca",
        model: "",
        seats: 2,
        acceleration: 5.6,
        maxSpeed: 0
    },
    "Vagner": {
        img: "vagner",
        desc: "",
        name: "Vagner",
        model: "",
        seats: 2,
        acceleration: 3.1,
        maxSpeed: 0
    },
    "Vamos": {
        img: "vamos",
        desc: "",
        name: "Vamos",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Vectre": {
        img: "vectre",
        desc: "",
        name: "Vectre",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Verlierer2": {
        img: "verlierer2",
        desc: "",
        name: "Verlierer2",
        model: "",
        seats: 2,
        acceleration: 5.1,
        maxSpeed: 0
    },
    "Viseris": {
        img: "viseris",
        desc: "",
        name: "Viseris",
        model: "",
        seats: 2,
        acceleration: 6.1,
        maxSpeed: 0
    },
    "Visione": {
        img: "visione",
        desc: "",
        name: "Visione",
        model: "",
        seats: 2,
        acceleration: 4.1,
        maxSpeed: 0
    },
    "Voltic": {
        img: "voltic",
        desc: "",
        name: "Voltic",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Voodoo": {
        img: "voodoo",
        desc: "",
        name: "Voodoo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Voodoo2": {
        img: "voodoo2",
        desc: "",
        name: "Voodoo2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Vstr": {
        img: "vstr",
        desc: "",
        name: "Vstr",
        model: "",
        seats: 4,
        acceleration: 8,
        maxSpeed: 0
    },
    "Warrener": {
        img: "warrener",
        desc: "",
        name: "Warrener",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Warrener2": {
        img: "warrener2",
        desc: "",
        name: "Warrener2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Washington": {
        img: "washington",
        desc: "",
        name: "Washington",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Weevil": {
        img: "weevil",
        desc: "",
        name: "Weevil",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Windsor": {
        img: "windsor",
        desc: "",
        name: "Windsor",
        model: "",
        seats: 2,
        acceleration: 7,
        maxSpeed: 0
    },
    "Windsor2": {
        img: "windsor2",
        desc: "",
        name: "Windsor2",
        model: "",
        seats: 4,
        acceleration: 7.3,
        maxSpeed: 0
    },
    "Xa21": {
        img: "xa21",
        desc: "",
        name: "Xa21",
        model: "",
        seats: 2,
        acceleration: 4.1,
        maxSpeed: 0
    },
    "XLS": {
        img: "xls",
        desc: "",
        name: "XLS",
        model: "",
        seats: 4,
        acceleration: 7,
        maxSpeed: 0
    },
    "Yosemite": {
        img: "yosemite",
        desc: "",
        name: "Yosemite",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Yosemite2": {
        img: "yosemite2",
        desc: "",
        name: "Yosemite2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Yosemite3": {
        img: "yosemite3",
        desc: "",
        name: "Yosemite3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Z190": {
        img: "z190",
        desc: "",
        name: "Z190",
        model: "",
        seats: 2,
        acceleration: 2,
        maxSpeed: 0
    },
    "Zentorno": {
        img: "zentorno",
        desc: "",
        name: "Zentorno",
        model: "",
        seats: 2,
        acceleration: 3.7,
        maxSpeed: 0
    },
    "Zeno": {
        img: "zeno",
        desc: "",
        name: "Zeno",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Zion": {
        img: "zion",
        desc: "",
        name: "Zion",
        model: "",
        seats: 2,
        acceleration: 0,
        maxSpeed: 0
    },
    "Zion2": {
        img: "zion2",
        desc: "",
        name: "Zion2",
        model: "",
        seats: 2,
        acceleration: 7.4,
        maxSpeed: 0
    },
    "Zion3": {
        img: "zion3",
        desc: "",
        name: "Zion3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Zorrusso": {
        img: "zorrusso",
        desc: "",
        name: "Zorrusso",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Zr350": {
        img: "zr350",
        desc: "",
        name: "Zr350",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ZType": {
        img: "ztype",
        desc: "",
        name: "ZType",
        model: "",
        seats: 2,
        acceleration: 6.7,
        maxSpeed: 0
    },
    "16challenger": {
        img: "16challenger",
        desc: "",
        name: "16challenger",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "AudiR8": {
        img: "audir8",
        desc: "",
        name: "AudiR8",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "AudiRS7": {
        img: "audirs7",
        desc: "",
        name: "AudiRS7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "AudiTT": {
        img: "auditt",
        desc: "",
        name: "AudiTT",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "BMWE38": {
        img: "bmwe38",
        desc: "",
        name: "BMWE38",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "BMWX6": {
        img: "bmwx6",
        desc: "",
        name: "BMWX6",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "BentleyB": {
        img: "bentleyb",
        desc: "",
        name: "BentleyB",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "BentleyC": {
        img: "bentleyc",
        desc: "",
        name: "BentleyC",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "BmwI8": {
        img: "bmwi8",
        desc: "",
        name: "BmwI8",
        model: "",
        seats: 2,
        acceleration: 4.6,
        maxSpeed: 0
    },
    "BmwM3": {
        img: "bmwm3",
        desc: "",
        name: "BmwM3",
        model: "",
        seats: 4,
        acceleration: 4.1,
        maxSpeed: 0
    },
    "BmwM5": {
        img: "bmwm5",
        desc: "",
        name: "BmwM5",
        model: "",
        seats: 4,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "BmwM8": {
        img: "bmwm8",
        desc: "",
        name: "BmwM8",
        model: "",
        seats: 2,
        acceleration: 4.3,
        maxSpeed: 0
    },
    "Btype3": {
        img: "btype3",
        desc: "",
        name: "Btype3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Caddy": {
        img: "caddy",
        desc: "",
        name: "Caddy",
        model: "",
        seats: 2,
        acceleration: 17.5,
        maxSpeed: 0
    },
    "Camry": {
        img: "camry",
        desc: "",
        name: "Camry",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Db11": {
        img: "db11",
        desc: "",
        name: "Db11",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "DodgeViper": {
        img: "dodgeviper",
        desc: "",
        name: "DodgeViper",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Ferrari488": {
        img: "ferrari488",
        desc: "",
        name: "Ferrari488",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Fudocycle": {
        img: "fudocycle",
        desc: "",
        name: "Fudocycle",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Hotknife": {
        img: "hotknife",
        desc: "",
        name: "Hotknife",
        model: "",
        seats: 2,
        acceleration: 6.6,
        maxSpeed: 0
    },
    "Italirsx": {
        img: "italirsx",
        desc: "",
        name: "Italirsx",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "LX570": {
        img: "lx570",
        desc: "",
        name: "LX570",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Lambo580": {
        img: "lambo580",
        desc: "",
        name: "Lambo580",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Lambo640": {
        img: "lambo640",
        desc: "",
        name: "Lambo640",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Lambo770": {
        img: "lambo770",
        desc: "",
        name: "Lambo770",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "MBC63": {
        img: "mbc63",
        desc: "",
        name: "MBC63",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "MBC63S": {
        img: "mbc63s",
        desc: "",
        name: "MBC63S",
        model: "",
        seats: 2,
        acceleration: 4.5,
        maxSpeed: 0
    },
    "MBE420": {
        img: "mbe420",
        desc: "",
        name: "MBE420",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "MBG63": {
        img: "mbg63",
        desc: "",
        name: "MBG63",
        model: "",
        seats: 4,
        acceleration: 9,
        maxSpeed: 0
    },
    "MLEvoX": {
        img: "mlevox",
        desc: "",
        name: "MLEvoX",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "MazdaRX7": {
        img: "mazdarx7",
        desc: "",
        name: "MazdaRX7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "NGTR": {
        img: "ngtr",
        desc: "",
        name: "NGTR",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Outlaw": {
        img: "outlaw",
        desc: "",
        name: "Outlaw",
        model: "",
        seats: 2,
        acceleration: 4.4,
        maxSpeed: 0
    },
    "RRSVR": {
        img: "rrsvr",
        desc: "",
        name: "RRSVR",
        model: "",
        seats: 4,
        acceleration: 10,
        maxSpeed: 0
    },
    "Regera": {
        img: "regera",
        desc: "",
        name: "Regera",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Romero": {
        img: "romero",
        desc: "",
        name: "Romero",
        model: "",
        seats: 4,
        acceleration: 15.2,
        maxSpeed: 0
    },
    "Ruston": {
        img: "ruston",
        desc: "",
        name: "Ruston",
        model: "",
        seats: 2,
        acceleration: 4.9,
        maxSpeed: 0
    },
    "Skyline": {
        img: "skyline",
        desc: "",
        name: "Skyline",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Stafford": {
        img: "stafford",
        desc: "",
        name: "Stafford",
        model: "",
        seats: 4,
        acceleration: 11.4,
        maxSpeed: 0
    },
    "SubaruWRX": {
        img: "subaruwrx",
        desc: "",
        name: "SubaruWRX",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "Supra": {
        img: "supra",
        desc: "",
        name: "Supra",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "TeslaS": {
        img: "teslas",
        desc: "",
        name: "TeslaS",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ZType": {
        img: "ztype",
        desc: "",
        name: "ZType",
        model: "",
        seats: 2,
        acceleration: 6.7,
        maxSpeed: 0
    },
    "audia6": {
        img: "audia6",
        desc: "",
        name: "audia6",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bmwx5": {
        img: "bmwx5",
        desc: "",
        name: "bmwx5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cadctsv": {
        img: "cadctsv",
        desc: "",
        name: "cadctsv",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "c7": {
        img: "c7",
        desc: "",
        name: "c7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "diablosv": {
        img: "diablosv",
        desc: "",
        name: "diablosv",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "escalade900": {
        img: "escalade900",
        desc: "",
        name: "escalade900",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "fxxkevo": {
        img: "fxxkevo",
        desc: "",
        name: "fxxkevo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gemera": {
        img: "gemera",
        desc: "",
        name: "gemera",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "impala67": {
        img: "impala67",
        desc: "",
        name: "impala67",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "jeepsrt8": {
        img: "jeepsrt8",
        desc: "",
        name: "jeepsrt8",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "jesko": {
        img: "jesko",
        desc: "",
        name: "jesko",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lexusgsf": {
        img: "lexusgsf",
        desc: "",
        name: "lexusgsf",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lp700r": {
        img: "lp700r",
        desc: "",
        name: "lp700r",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "markii": {
        img: "markii",
        desc: "",
        name: "markii",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mbamggt": {
        img: "mbamggt",
        desc: "",
        name: "mbamggt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mbx18": {
        img: "mbx18",
        desc: "",
        name: "mbx18",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "minic": {
        img: "minic",
        desc: "",
        name: "minic",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "p1": {
        img: "p1",
        desc: "",
        name: "p1",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "panamera": {
        img: "panamera",
        desc: "",
        name: "panamera",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "porschegt4": {
        img: "porschegt4",
        desc: "",
        name: "porschegt4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rrcullinan": {
        img: "rrcullinan",
        desc: "",
        name: "rrcullinan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sian": {
        img: "sian",
        desc: "",
        name: "sian",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "silvias15": {
        img: "silvias15",
        desc: "",
        name: "silvias15",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "taycan": {
        img: "taycan",
        desc: "",
        name: "taycan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "urus": {
        img: "urus",
        desc: "",
        name: "urus",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "vapidse": {
        img: "vapidse",
        desc: "",
        name: "vapidse",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "w223": {
        img: "w223",
        desc: "",
        name: "w223",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "190e": {
        img: "190e",
        desc: "",
        name: "190e",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "5series": {
        img: "5series",
        desc: "",
        name: "5series",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "5series2": {
        img: "5series2",
        desc: "",
        name: "5series2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "aclass2": {
        img: "aclass2",
        desc: "",
        name: "aclass2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "air": {
        img: "air",
        desc: "",
        name: "air",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "amggt2": {
        img: "amggt2",
        desc: "",
        name: "amggt2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bentayga2": {
        img: "bentayga2",
        desc: "",
        name: "bentayga2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bronco": {
        img: "bronco",
        desc: "",
        name: "bronco",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "brz": {
        img: "brz",
        desc: "",
        name: "brz",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "carrera": {
        img: "carrera",
        desc: "",
        name: "carrera",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cc850": {
        img: "cc850",
        desc: "",
        name: "cc850",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "charger2": {
        img: "charger2",
        desc: "",
        name: "charger2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "charger3": {
        img: "charger3",
        desc: "",
        name: "charger3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "chiron19": {
        img: "chiron19",
        desc: "",
        name: "chiron19",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "civic": {
        img: "civic",
        desc: "",
        name: "civic",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "civic2": {
        img: "civic2",
        desc: "",
        name: "civic2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "corvette3": {
        img: "corvette3",
        desc: "",
        name: "corvette3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "countach": {
        img: "countach",
        desc: "",
        name: "countach",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "countryman": {
        img: "countryman",
        desc: "",
        name: "countryman",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cybertruck": {
        img: "cybertruck",
        desc: "",
        name: "cybertruck",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "d8": {
        img: "d8",
        desc: "",
        name: "d8",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "daytona": {
        img: "daytona",
        desc: "",
        name: "daytona",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "db112": {
        img: "db112",
        desc: "",
        name: "db112",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "durango": {
        img: "durango",
        desc: "",
        name: "durango",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "eclass3": {
        img: "eclass3",
        desc: "",
        name: "eclass3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "eclass4": {
        img: "eclass4",
        desc: "",
        name: "eclass4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "eclipse": {
        img: "eclipse",
        desc: "",
        name: "eclipse",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "emira": {
        img: "emira",
        desc: "",
        name: "emira",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "eqs": {
        img: "eqs",
        desc: "",
        name: "eqs",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "escalade2": {
        img: "escalade2",
        desc: "",
        name: "escalade2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "evija": {
        img: "evija",
        desc: "",
        name: "evija",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "f150": {
        img: "f150",
        desc: "",
        name: "f150",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "f1502": {
        img: "f1502",
        desc: "",
        name: "f1502",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "fury": {
        img: "fury",
        desc: "",
        name: "fury",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "golf2": {
        img: "golf2",
        desc: "",
        name: "golf2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gtr32": {
        img: "gtr32",
        desc: "",
        name: "gtr32",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "hummer4": {
        img: "hummer4",
        desc: "",
        name: "hummer4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "hummer5": {
        img: "hummer5",
        desc: "",
        name: "hummer5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "huracan": {
        img: "huracan",
        desc: "",
        name: "huracan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "huracan2": {
        img: "huracan2",
        desc: "",
        name: "huracan2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "i82": {
        img: "i82",
        desc: "",
        name: "i82",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "impala2": {
        img: "impala2",
        desc: "",
        name: "impala2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "invencible": {
        img: "invencible",
        desc: "",
        name: "invencible",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ix": {
        img: "ix",
        desc: "",
        name: "ix",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "j50": {
        img: "j50",
        desc: "",
        name: "j50",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "k5": {
        img: "k5",
        desc: "",
        name: "k5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lanzador": {
        img: "lanzador",
        desc: "",
        name: "lanzador",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lc500": {
        img: "lc500",
        desc: "",
        name: "lc500",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "levante": {
        img: "levante",
        desc: "",
        name: "levante",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lfa": {
        img: "lfa",
        desc: "",
        name: "lfa",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m2g42": {
        img: "m2g42",
        desc: "",
        name: "m2g42",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "macan2": {
        img: "macan2",
        desc: "",
        name: "macan2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "modelt": {
        img: "modelt",
        desc: "",
        name: "modelt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mustang3": {
        img: "mustang3",
        desc: "",
        name: "mustang3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mx5": {
        img: "mx5",
        desc: "",
        name: "mx5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "nsx2": {
        img: "nsx2",
        desc: "",
        name: "nsx2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "panamera2": {
        img: "panamera2",
        desc: "",
        name: "panamera2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "polestar": {
        img: "polestar",
        desc: "",
        name: "polestar",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "q60s": {
        img: "q60s",
        desc: "",
        name: "q60s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ram": {
        img: "ram",
        desc: "",
        name: "ram",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ram2": {
        img: "ram2",
        desc: "",
        name: "ram2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s15": {
        img: "s15",
        desc: "",
        name: "s15",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s2000": {
        img: "s2000",
        desc: "",
        name: "s2000",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "senna": {
        img: "senna",
        desc: "",
        name: "senna",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sl": {
        img: "sl",
        desc: "",
        name: "sl",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "speedtail": {
        img: "speedtail",
        desc: "",
        name: "speedtail",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tecnomar": {
        img: "tecnomar",
        desc: "",
        name: "tecnomar",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tourbillon": {
        img: "tourbillon",
        desc: "",
        name: "tourbillon",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tt": {
        img: "tt",
        desc: "",
        name: "tt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tt2": {
        img: "tt2",
        desc: "",
        name: "tt2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "utopia": {
        img: "utopia",
        desc: "",
        name: "utopia",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "valour": {
        img: "valour",
        desc: "",
        name: "valour",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "2020mustang": {
        img: "2020mustang",
        desc: "",
        name: "2020mustang",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "370z": {
        img: "370z",
        desc: "",
        name: "370z",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "400z": {
        img: "400z",
        desc: "",
        name: "400z",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "488pista": {
        img: "488pista",
        desc: "",
        name: "488pista",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "63gls": {
        img: "63gls",
        desc: "",
        name: "63gls",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "63gls2": {
        img: "63gls2",
        desc: "",
        name: "63gls2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "718bs": {
        img: "718bs",
        desc: "",
        name: "718bs",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "720s": {
        img: "720s",
        desc: "",
        name: "720s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "918s": {
        img: "918s",
        desc: "",
        name: "918s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "a80": {
        img: "a80",
        desc: "",
        name: "a80",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ab2": {
        img: "ab2",
        desc: "",
        name: "ab2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "accord": {
        img: "accord",
        desc: "",
        name: "accord",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "actros": {
        img: "actros",
        desc: "",
        name: "actros",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ae86": {
        img: "ae86",
        desc: "",
        name: "ae86",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "aeroboat": {
        img: "aeroboat",
        desc: "",
        name: "aeroboat",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "amggt": {
        img: "amggt",
        desc: "",
        name: "amggt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "amgone": {
        img: "amgone",
        desc: "",
        name: "amgone",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ast": {
        img: "ast",
        desc: "",
        name: "ast",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "asvj": {
        img: "asvj",
        desc: "",
        name: "asvj",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "avtr": {
        img: "avtr",
        desc: "",
        name: "avtr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bacalar": {
        img: "bacalar",
        desc: "",
        name: "bacalar",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bcsod": {
        img: "bcsod",
        desc: "",
        name: "bcsod",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bcsog": {
        img: "bcsog",
        desc: "",
        name: "bcsog",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bcsor": {
        img: "bcsor",
        desc: "",
        name: "bcsor",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bdivo": {
        img: "bdivo",
        desc: "",
        name: "bdivo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bison4": {
        img: "bison4",
        desc: "",
        name: "bison4",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bmwe39": {
        img: "bmwe39",
        desc: "",
        name: "bmwe39",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bmwg20": {
        img: "bmwg20",
        desc: "",
        name: "bmwg20",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bmwm7": {
        img: "bmwm7",
        desc: "",
        name: "bmwm7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bmwx7": {
        img: "bmwx7",
        desc: "",
        name: "bmwx7",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bolide": {
        img: "bolide",
        desc: "",
        name: "bolide",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "brutale": {
        img: "brutale",
        desc: "",
        name: "brutale",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "brz13": {
        img: "brz13",
        desc: "",
        name: "brz13",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "bug300ss": {
        img: "bug300ss",
        desc: "",
        name: "bug300ss",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "c300": {
        img: "c300",
        desc: "",
        name: "c300",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "c8z023": {
        img: "c8z023",
        desc: "",
        name: "c8z023",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "camaro2": {
        img: "camaro2",
        desc: "",
        name: "camaro2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "camaro21": {
        img: "camaro21",
        desc: "",
        name: "camaro21",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "camry2": {
        img: "camry2",
        desc: "",
        name: "camry2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "camry70": {
        img: "camry70",
        desc: "",
        name: "camry70",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cayen19": {
        img: "cayen19",
        desc: "",
        name: "cayen19",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cayenne2": {
        img: "cayenne2",
        desc: "",
        name: "cayenne2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "centenario": {
        img: "centenario",
        desc: "",
        name: "centenario",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cesc21": {
        img: "cesc21",
        desc: "",
        name: "cesc21",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "charger20": {
        img: "charger20",
        desc: "",
        name: "charger20",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cls2": {
        img: "cls2",
        desc: "",
        name: "cls2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cls63s": {
        img: "cls63s",
        desc: "",
        name: "cls63s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "clubgtr": {
        img: "clubgtr",
        desc: "",
        name: "clubgtr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "continental": {
        img: "continental",
        desc: "",
        name: "continental",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "corvett08": {
        img: "corvett08",
        desc: "",
        name: "corvett08",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "corvette2": {
        img: "corvette2",
        desc: "",
        name: "corvette2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "cullinan": {
        img: "cullinan",
        desc: "",
        name: "cullinan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "dawn": {
        img: "dawn",
        desc: "",
        name: "dawn",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "db5": {
        img: "db5",
        desc: "",
        name: "db5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "dbx": {
        img: "dbx",
        desc: "",
        name: "dbx",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "delorean": {
        img: "delorean",
        desc: "",
        name: "delorean",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "diabloSV": {
        img: "diabloSV",
        desc: "",
        name: "diabloSV",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "diavel": {
        img: "diavel",
        desc: "",
        name: "diavel",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "e63s": {
        img: "e63s",
        desc: "",
        name: "e63s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ec120": {
        img: "ec120",
        desc: "",
        name: "ec120",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ec135": {
        img: "ec135",
        desc: "",
        name: "ec135",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "essenza": {
        img: "essenza",
        desc: "",
        name: "essenza",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "etron": {
        img: "etron",
        desc: "",
        name: "etron",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "evo10": {
        img: "evo10",
        desc: "",
        name: "evo10",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "evo9": {
        img: "evo9",
        desc: "",
        name: "evo9",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "f40": {
        img: "f40",
        desc: "",
        name: "f40",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ferocid": {
        img: "ferocid",
        desc: "",
        name: "ferocid",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ff12": {
        img: "ff12",
        desc: "",
        name: "ff12",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "focusrs": {
        img: "focusrs",
        desc: "",
        name: "focusrs",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "fordgt": {
        img: "fordgt",
        desc: "",
        name: "fordgt",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "ftype": {
        img: "ftype",
        desc: "",
        name: "ftype",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "fx50s": {
        img: "fx50s",
        desc: "",
        name: "fx50s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "g55": {
        img: "g55",
        desc: "",
        name: "g55",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gle2": {
        img: "gle2",
        desc: "",
        name: "gle2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gle63": {
        img: "gle63",
        desc: "",
        name: "gle63",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "golf7r": {
        img: "golf7r",
        desc: "",
        name: "golf7r",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gsx1000": {
        img: "gsx1000",
        desc: "",
        name: "gsx1000",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gt63s": {
        img: "gt63s",
        desc: "",
        name: "gt63s",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "gtr50": {
        img: "gtr50",
        desc: "",
        name: "gtr50",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "hellion2": {
        img: "hellion2",
        desc: "",
        name: "hellion2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "imola": {
        img: "imola",
        desc: "",
        name: "imola",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "jesko20": {
        img: "jesko20",
        desc: "",
        name: "jesko20",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "jester5": {
        img: "jester5",
        desc: "",
        name: "jester5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "jgc": {
        img: "jgc",
        desc: "",
        name: "jgc",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "kiastinger": {
        img: "kiastinger",
        desc: "",
        name: "kiastinger",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "l650": {
        img: "l650",
        desc: "",
        name: "l650",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "laferrari": {
        img: "laferrari",
        desc: "",
        name: "laferrari",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lc200": {
        img: "lc200",
        desc: "",
        name: "lc200",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lc300": {
        img: "lc300",
        desc: "",
        name: "lc300",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lex570": {
        img: "lex570",
        desc: "",
        name: "lex570",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m3e46": {
        img: "m3e46",
        desc: "",
        name: "m3e46",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m3g81": {
        img: "m3g81",
        desc: "",
        name: "m3g81",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m3gtr": {
        img: "m3gtr",
        desc: "",
        name: "m3gtr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m4comp": {
        img: "m4comp",
        desc: "",
        name: "m4comp",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m4f82": {
        img: "m4f82",
        desc: "",
        name: "m4f82",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m5comp": {
        img: "m5comp",
        desc: "",
        name: "m5comp",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m5e60": {
        img: "m5e60",
        desc: "",
        name: "m5e60",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m750li": {
        img: "m750li",
        desc: "",
        name: "m750li",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m7g70": {
        img: "m7g70",
        desc: "",
        name: "m7g70",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m850": {
        img: "m850",
        desc: "",
        name: "m850",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "m8gc": {
        img: "m8gc",
        desc: "",
        name: "m8gc",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "macan": {
        img: "macan",
        desc: "",
        name: "macan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "models": {
        img: "models",
        desc: "",
        name: "models",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "modelx": {
        img: "modelx",
        desc: "",
        name: "modelx",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "monza": {
        img: "monza",
        desc: "",
        name: "monza",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mp1": {
        img: "mp1",
        desc: "",
        name: "mp1",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mustang2": {
        img: "mustang2",
        desc: "",
        name: "mustang2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "nisgtr": {
        img: "nisgtr",
        desc: "",
        name: "nisgtr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "nsx": {
        img: "nsx",
        desc: "",
        name: "nsx",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "octavia18": {
        img: "octavia18",
        desc: "",
        name: "octavia18",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "panamera17turbo": {
        img: "panamera17turbo",
        desc: "",
        name: "panamera17turbo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "pts21": {
        img: "pts21",
        desc: "",
        name: "pts21",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "purosangue": {
        img: "purosangue",
        desc: "",
        name: "purosangue",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "q8": {
        img: "q8",
        desc: "",
        name: "q8",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "r66": {
        img: "r66",
        desc: "",
        name: "r66",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "r820": {
        img: "r820",
        desc: "",
        name: "r820",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "reventon": {
        img: "reventon",
        desc: "",
        name: "reventon",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "revuelto": {
        img: "revuelto",
        desc: "",
        name: "revuelto",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rio": {
        img: "rio",
        desc: "",
        name: "rio",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rrab": {
        img: "rrab",
        desc: "",
        name: "rrab",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rrphantom": {
        img: "rrphantom",
        desc: "",
        name: "rrphantom",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rrs": {
        img: "rrs",
        desc: "",
        name: "rrs",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rs5": {
        img: "rs5",
        desc: "",
        name: "rs5",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rs6": {
        img: "rs6",
        desc: "",
        name: "rs6",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "rs72": {
        img: "rs72",
        desc: "",
        name: "rs72",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s1000rr": {
        img: "s1000rr",
        desc: "",
        name: "s1000rr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s230": {
        img: "s230",
        desc: "",
        name: "s230",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s600": {
        img: "s600",
        desc: "",
        name: "s600",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s63cab": {
        img: "s63cab",
        desc: "",
        name: "s63cab",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "s63w222": {
        img: "s63w222",
        desc: "",
        name: "s63w222",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sahpicv": {
        img: "sahpicv",
        desc: "",
        name: "sahpicv",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "samara": {
        img: "samara",
        desc: "",
        name: "samara",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sclass3": {
        img: "sclass3",
        desc: "",
        name: "sclass3",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sf90": {
        img: "sf90",
        desc: "",
        name: "sf90",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sigma2": {
        img: "sigma2",
        desc: "",
        name: "sigma2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "slr": {
        img: "slr",
        desc: "",
        name: "slr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "sprinter": {
        img: "sprinter",
        desc: "",
        name: "sprinter",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "subwrx": {
        img: "subwrx",
        desc: "",
        name: "subwrx",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "supragr": {
        img: "supragr",
        desc: "",
        name: "supragr",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "t680": {
        img: "t680",
        desc: "",
        name: "t680",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tahoe2": {
        img: "tahoe2",
        desc: "",
        name: "tahoe2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "terzo": {
        img: "terzo",
        desc: "",
        name: "terzo",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "touareg": {
        img: "touareg",
        desc: "",
        name: "touareg",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "touareg2": {
        img: "touareg2",
        desc: "",
        name: "touareg2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "urban": {
        img: "urban",
        desc: "",
        name: "urban",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "vclass": {
        img: "vclass",
        desc: "",
        name: "vclass",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "206gti": {
        img: "206gti",
        desc: "",
        name: "206gti",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "atlantic": {
        img: "atlantic",
        desc: "",
        name: "atlantic",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "fordraptor": {
        img: "fordraptor",
        desc: "",
        name: "fordraptor",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "lambo770p": {
        img: "lambo770p",
        desc: "",
        name: "lambo770p",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "mysterycar": {
        img: "mysterycar",
        desc: "",
        name: "mysterycar",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "snowbike": {
        img: "snowbike",
        desc: "",
        name: "snowbike",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "velar": {
        img: "velar",
        desc: "",
        name: "velar",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "veneno": {
        img: "veneno",
        desc: "",
        name: "veneno",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "vesta": {
        img: "vesta",
        desc: "",
        name: "vesta",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "vincent2": {
        img: "vincent2",
        desc: "",
        name: "vincent2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "volvoxc90": {
        img: "volvoxc90",
        desc: "",
        name: "volvoxc90",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "vulcan": {
        img: "vulcan",
        desc: "",
        name: "vulcan",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "w210": {
        img: "w210",
        desc: "",
        name: "w210",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "wraithb": {
        img: "wraithb",
        desc: "",
        name: "wraithb",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "x5g05": {
        img: "x5g05",
        desc: "",
        name: "x5g05",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "x5me70": {
        img: "x5me70",
        desc: "",
        name: "x5me70",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "x6m2": {
        img: "x6m2",
        desc: "",
        name: "x6m2",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "xes": {
        img: "xes",
        desc: "",
        name: "xes",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "xm": {
        img: "xm",
        desc: "",
        name: "xm",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "z4b": {
        img: "z4b",
        desc: "",
        name: "z4b",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "z800": {
        img: "z800",
        desc: "",
        name: "z800",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "zagatosb": {
        img: "zagatosb",
        desc: "",
        name: "zagatosb",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "zionks": {
        img: "zionks",
        desc: "",
        name: "zionks",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "offlrds1000r": {
        img: "offlrds1000r",
        desc: "",
        name: "offlrds1000r",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    },
    "tour26": {
        img: "tour26",
        desc: "",
        name: "tour26",
        model: "",
        seats: 2,
        acceleration: 4,
        maxSpeed: 0
    }
};